import { useAppSelector } from '@frontend/common';
import { StockConstraintData, isStockConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { StockConstraintDataInputProps } from './stock-constraint-data-input.component';

interface ViewProps {
    formValues: StockConstraintData;
}

const useStockConstraintDataInput = (props: StockConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isStockConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { quantity: 1 } }));
        }
    }, []);
    return {
        formValues
    };
};

export default useStockConstraintDataInput;
